module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobotconfirmed_pt_BR.235a9692.png";